import {
    ETicketTypesPage,
    ETicketsPage,
    ImportETicketsPage
} from '@pages';

export const SettingsTabs = () => {
    return [
        {
            label: 'Liste des e-billets',
            path: 'etickets',
            component: <ETicketsPage />
        },
        {
            label: 'Import des e-billets',
            path: 'import-etickets',
            component: <ImportETicketsPage />
        },
        {
            label: 'Type de e-billets',
            path: 'eticket-types',
            component: <ETicketTypesPage />
        },
    ];
};
